import { useMatchedBreakpoints } from '@react-spectrum/utils';

export const useMatchingBreakpoints = (): MatchingBreakpoints => {
	const matchedBreakpoints = useMatchedBreakpoints(BREAKPOINTS);
	const matchingBreakpoints = {} as MatchingBreakpoints;
	for (const key of Object.keys(BREAKPOINTS) as BreakpointKey[]) {
		if (matchedBreakpoints.includes(key)) {
			matchingBreakpoints[`is${key}`] = true;
		} else {
			matchingBreakpoints[`is${key}`] = false;
		}
	}
	return matchingBreakpoints;
};

type BreakpointKey = 'S' | 'M' | 'L' | 'XL' | 'XXL' | 'XXXL';

export const BREAKPOINTS: Record<BreakpointKey, number> = {
	S: 600,
	M: 900,
	L: 1024,
	XL: 1200,
	XXL: 1440,
	XXXL: 1920,
} as const;

/**
 * Breakpoint matching results
 */
type MatchingBreakpoints = {
	/** Matches when viewport width is >= 600px */
	isS: boolean;
	/** Matches when viewport width is >= 900px */
	isM: boolean;
	/** Matches when viewport width is >= 1024px */
	isL: boolean;
	/** Matches when viewport width is >= 1200px */
	isXL: boolean;
	/** Matches when viewport width is >= 1440px */
	isXXL: boolean;
	/** Matches when viewport width is >= 1920px */
	isXXXL: boolean;
};
